# static pre-computed dicts and lists

import colorsys from 'colorsys'

# getColor: (score) ->
#     return "white" if not score
#     color = colorsys.hsv_to_rgb
#         h: (score + 10) / 100 * 240 - 120
#         s: 50
#         v: 95
#     console.log(color)
#     return "rgb(#{color.r}, #{color.g}, #{color.b})"

state =
    score_color: {score: (
        # return "white" if not score
        color = colorsys.hsv_to_rgb
            h: (score + 10) / 100 * 240 - 120
            s: 50
            v: 95
        "rgb(#{color.r}, #{color.g}, #{color.b})"
    ) for score in [0..100]}
    koen: {score : 'rgb(150, 242, 121)' for score in [0..100]}

export default {
    namespaced: true
    state
}